import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Store } from '@ngrx/store';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(auth, router, store) {
        this.auth = auth;
        this.router = router;
        this.store = store;
    }
    AuthGuard.prototype.canActivate = function () {
        if (this.auth.loggedIn()) {
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    };
    return AuthGuard;
}());
export { AuthGuard };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/auth-guard.service.ts.pre-build-optimizer.js